import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Help from "@material-ui/icons/Help";
import moment from "moment";
import Moment from "react-moment";
import axios from "axios";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { BreadcrumbPage } from "../../shared";
import { CommonCss } from "../../services/CommonCss";
import { getRequest, putRequest } from "../../services/ApiServices";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import clsx from "clsx";
import Confirmation from "../../shared/alerts/Confirmation";
import { LOADING } from "../../action/index";
import { useSelector, useDispatch } from 'react-redux';
import { getCookie } from "../../services/Cookies";
import EllipsisText from "react-ellipsis-text";
import { cookieKeys } from "../../services/Cookies";
import MUIDataTable from "mui-datatables";

import { ThemeProvider } from "@mui/styles";

import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import searchicon from '../Helpsection_images/searchicon.jpg';
import printicon from '../Helpsection_images/printicon.jpg';
import downloadicon from '../Helpsection_images/downloadicon.jpg';
import viewcolumnicon from '../Helpsection_images/viewcolumnicon.jpg';
import filtericon from '../Helpsection_images/filtericon.jpg';
import Checkbox from '../Helpsection_images/Checkbox.jpg';
import DeleteIcon from '@mui/icons-material/Delete';
const getMuiTheme = () => createTheme({

  overrides: {
    MUIDataTableHeadCell: {
      root: {
        textTransform: "none"
      }
    }
  }
})
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  tableBody:{
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#FF4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#FF4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",
    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 20
    }
  },
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "0px 0px 2px 1px rgb(0 0 0 / 12%)",
    borderRadius: 8,
  },
  tableLayout: {
    border: 0,
    boxShadow: "0 0 0 0 !important",
  },
  txtInput: {
    "& input": {
      padding: "4px 8px",
      fontWeight: 600,
    },
    "& fieldset": {},
  },
  breadcrumbBox: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  link: {
    textTransform: "capitalize",
    //color: "#ff4717 ",
    fontSize: "17px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    '&:hover': {
      "text-decoration": "underline",
      cursor: "pointer",
      background: "none",
    }

  },
  Attachmentlink: {
    textTransform: "capitalize",
    //color: "#ff4717 ",
    fontSize: "15px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    '&:hover': {
      "text-decoration": "underline",
      cursor: "pointer",
      background: "none",
    }

  },
}));


// function Row(props) {
//   const { row, updateUserStatus, editUserDetails,onDownloadPic} = props;
//   const history = useHistory();
//   const [open, setOpen] = React.useState(false);
//   const classes = useStyles();
//   const classesCommonCss = CommonCss();
//   const [openAlert, setOpenAlert] = React.useState(false);
//   const [activeUser, setActiveUser] = React.useState({});
//   //const [formObj, setFormObj]=useState([]);
//    return (
//     <React.Fragment>
//       <TableRow style={{ overflow: "scroll" }}
//         >
//       <TableCell>{row.ticketId}</TableCell>
//         <TableCell>{row.raisedby}</TableCell>
//         <TableCell><EllipsisText text={row.description||""} length={30} /></TableCell>
//         <TableCell  style={{cursor: "pointer"}} onClick={()=>{onDownloadPic(row.attachmentId,"click")}} ><EllipsisText text={row.attachmentId} length={15} /></TableCell>
//         <TableCell>{row.status}</TableCell>
//         <TableCell>{row.createddate ? <Moment format="DD MMM YYYY">{row.createddate}</Moment> : ""}</TableCell>

//         <TableCell>{row.lastmodifieddate ? <Moment format="DD MMM YYYY ">{row.lastmodifieddate}</Moment> : ""}</TableCell>
//         {/* <TableCell onClick={()=>{handleClickOpen(row)}}>
//           {row.status=='Registered' || row.status=='Pending'?(<span className ={clsx(classesCommonCss.pending, classesCommonCss.cursorPointer)}>Pending</span>):row.status=='Denied'?(<span  className ={clsx(classesCommonCss.inactive, classesCommonCss.cursorPointer)}>Inactive</span>):(<span  className ={clsx(classesCommonCss.active, classesCommonCss.cursorPointer)}>{row.status}</span>)}</TableCell> */}
//          <TableCell className={classesCommonCss.cursorPointer} onClick={()=>{editUserDetails(row)}}>{"Edit"}</TableCell> 

//       </TableRow>
//      {/*  <Confirmation  open={openAlert} onClose={handleClose} onHandleSubmit ={onAlertSubmit} /> */}
//     </React.Fragment>
//   );
// }

// Row.propTypes = {
//   row: PropTypes.shape({
//     username: PropTypes.string.isRequired,
//   }).isRequired,
// }

export default function AdminPanel() {
  const classes = useStyles();
  const history = useHistory();
  const classesCommonCss = CommonCss();
  const dispatch = useDispatch();
  const BreadcrumbList = [{ name: "Support Ticket", url: "" }];
  const [scroll, setScroll] = React.useState('paper');
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [selectedregisteredUsers, setSelectedRegisteredUsers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loadedRegisteredUsers, setLoadedRegisteredUsers] = useState([]);


  const [openform, setOpenform] = React.useState(false);
  const handleClickOpenForm = () => {
    setOpenform(true);
  };
  const handleClickClose = () => {
    setOpenform(false);
  };

  const onUpdateUserStatus = (obj) => {
  }

  const onEditUserDetails = (obj) => {
    ;
    history.push("/dashboard/SupportticketEdit/" + obj.ticketId);
  }

  const getSupportUser = () => {
    // //;
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      "SupportTicket/retriveTicket";
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setSearchText("");
          res.data.forEach((d) => {
            if(d.createddate){
            d.createddate=moment(d.createddate).format('DD/MM/YYYY');
            }
            if(d.lastmodifieddate){
d.lastmodifieddate=moment(d.lastmodifieddate).format('DD/MM/YYYY');
            }
          })
          setRegisteredUsers(res.data);
          onDownloadPic(res.data[0].attachmentId);
          // console.log(res.data);
          setLoadedRegisteredUsers(res.data);

        } else {
          dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        ToastError(error.response.data.message);
        dispatch({ type: LOADING, payload: false });
      });
  }

  useEffect(() => {
    getSupportUser();
  }, []);
  //console.log(registeredUsers);
  const onDownloadPic = (data, type = "onload") => {
    ////console.log(formObj.attachmentId)
    //
    dispatch({ type: LOADING, payload: true });
    const token = getCookie("token");
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `SupportTicket/downloadFile`;
    let filedata = JSON.stringify({ fileName: data });
    ////console.log(formObj.attachmentId );
    let config = {
      method: "post",
      responseType: "blob",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: " image/jpeg,image/jpg,image/png,image/gif"
      },
      data: filedata,
    };
    axios(config)
      .then(async function (response) {
        //console.log(response);
        if (response.status == 200) {
          dispatch({ type: LOADING, payload: false });
          const file = new Blob([response.data], { type: "image/jpeg,image/jpg,image/png,image/gif" });
          //Build a URL from the file
          //console.log(file)
          const fileURL = URL.createObjectURL(file);
          //console.log(fileURL);
          const userData = {
            profileImgPath: fileURL
          }
          cookieKeys(userData, 30 * 60);
          //getProfilepic(fileURL);
          if (type == "click") {
            window.open(fileURL, '_blank');
          }
        } else {
          ToastError(response.data.message);
        }
      })
      .catch(function (error) {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);
      });
  };
  const matchRuleShort = (str, rule) => {
    var escapeRegex = (str) => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");





    return new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$", "i").test(str)




  }
  const filterGrid = () => {
    ;
    //const rgUser = registeredUsers.filter(() => { return true; });
    const rgUser = loadedRegisteredUsers.filter(() => { return true; });

    setRegisteredUsers(rgUser.filter((item) => {

      return matchRuleShort(item.ticketId, "*" + searchText + "*") || matchRuleShort(item.raisedby, "*" + searchText + "*") || matchRuleShort(item.status, "*" + searchText + "*")
    }));

  }
  const columns = [
    {
      name: "ticketId",
      label: "Ticket Id",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "raisedby",
      label: "Name",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "description",
      label: "	Description",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "attachmentId",
      label: "		Attachment Id",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (Value, tableMeta) => {
          //
          return <button className={classes.Attachmentlink} onClick={() => { onDownloadPic(registeredUsers[tableMeta.rowIndex].attachmentId, "click") }}> <EllipsisText text={registeredUsers[tableMeta.rowIndex].attachmentId} length={15}/></button>
        }
      }
    },
    {
      name: "status",
      label: "	Status",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "createddate",
      label: "Created Date",
      options: {
        
        filter: true,
        sort: true,
        // filterOptions: {
          
        //   renderValue: (value) =>  {
        //     return <Moment format="DD/MM/YYYY">{value}</Moment>
        //   }
        // },
        // customBodyRender: (value) => {
          
        //   return <Moment format="DD/MM/YYYY">{value}</Moment>
          

        // }
      }
    },

    {
      name: "lastmodifieddate",
      label: "		Last Modified Date",
      options: {
        filter: true,
        sort: true,
        // filterOptions: {
          
        //   renderValue: (value) =>  {
        //     return <Moment format="DD/MM/YYYY">{value}</Moment>
        //   }
        // },
        // customBodyRender: (value) => {
          
        //   return <Moment format="DD/MM/YYYY">{value}</Moment>

        // }
      }
    },
    {
      name: "Edit",
      label: "		Actions",
      options: {
        filter: false,
        sort: true,
        download: false,

        customBodyRender: (Value, tableMeta) => {
          return <button className={classes.link} onClick={() => { onEditUserDetails(registeredUsers[tableMeta.currentTableData[tableMeta.rowIndex].index]) }}>Edit </button>
        }
      }
    },

  ];
  const options = {
    customToolbarSelect: () => {
      <>
        onRowsDelete:True,
      </>

    },
    selectToolbarPlacement: "above",
    selectableRows: "multiple",
    responsive: 'standard',
    filterType: 'multiselect',
    rowsPerPageOptions: [10, 15, 50, 100],
    downloadOptions:{
      filterOptions:{
        useDisplayedColumnsOnly:true,
        useDisplayedRowsOnly:true
      }
     },
     onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
      //debugger
      let isSupportTicket = [];

      rowsSelected.forEach((d) => {
        isSupportTicket.push(registeredUsers[d]);
      })
      console.log("isSupportTicket", isSupportTicket);
      setSelectedRegisteredUsers(isSupportTicket);
    },
    onDownload: (buildHead, buildBody, columns, gridData) => {
      var myData = [];
        var newKeys = Object.keys(registeredUsers[0]);
        var idx = 0;
        var columnsExport = [];
        var columnsExport1 = [];
        columnsExport.push("");
        columns.forEach((cl) => {
          if(cl.label!=="\t\tActions")
          columnsExport.push(cl.label);

        })
        // newKeys.forEach((k) => {
        //   columnsExport.push(k);
        // });
        columnsExport.push("\n");
        let i = 0;

        //console.log(item);
        selectedregisteredUsers.length > 0 ?
          (
            selectedregisteredUsers.forEach((item) => {
              let visibleRows = gridData.filter((df) => {
                let dfdt = df.data;
                if (dfdt[0] == item.ticketId && dfdt[1] == item.raisedby)
                  return true;
                else
                  return false;

              });
              if (visibleRows.length > 0) {

                let itemData = { ...item };
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;
                
                itemData.description = itemData.description?.replace(/[\r\n,]/g, "");
                itemData.createddate = itemData.createddate ? itemData.createddate : "";
                itemData.lastmodifieddate = itemData.lastmodifieddate ? itemData.lastmodifieddate : "";

                let objSupportTicket = {
                  TicketId: itemData.ticketId,
                  Name: itemData.raisedby,
                  Description: itemData.description,
                  AttachmentId: itemData.attachmentId,
                  Status: itemData.status,
                  CreatedDate: itemData.createddate,
                  LastmodifiedDate: itemData.lastmodifieddate,
                }
                let data = [];
                data.push(...Object.values({ ...objSupportTicket }));
                data.push("\n");
                dataItem.push(data);
                // });
                myData.push(...dataItem);
                // console.log("myData",myData)
              }
            })
          ):(
            registeredUsers.forEach((item) => {
              let visibleRows = gridData.filter((df) => {
                let dfdt = df.data;
                if (dfdt[0] == item.ticketId && dfdt[1] == item.raisedby)
                  return true;
                else
                  return false;

              });
              if (visibleRows.length > 0) {

                let itemData = { ...item };
                let dataItem = []
                if (i == 0)
                  dataItem.push("");
                i++;

                itemData.description = itemData.description?.replace(/[\r\n,]/g, "");
                itemData.createddate = itemData.createddate ? itemData.createddate : "";
                itemData.lastmodifieddate = itemData.lastmodifieddate ? itemData.lastmodifieddate : "";

                let objSupportTicket = {
                  TicketId: itemData.ticketId,
                  Name: itemData.raisedby,
                  Description: itemData.description,
                  AttachmentId: itemData.attachmentId,
                  Status: itemData.status,
                  CreatedDate: itemData.createddate,
                  LastmodifiedDate: itemData.lastmodifieddate,
                }
                let data = [];
                data.push(...Object.values({ ...objSupportTicket }));
                data.push("\n");
                dataItem.push(data);
                // });
                myData.push(...dataItem);
                // console.log("myData",myData)
              }
            })
          )
          buildHead = () => {
            console.log(columnsExport);
            return columnsExport;
          }
          buildBody = () => {
            // console.log(myData);
            return myData;
          }
          return buildHead() + buildBody();
    }

    /*onDownload: (buildHead, buildBody, columns, data) => {
      console.log("Useranalytics custom onDownload","buildeader : ",buildHead," body : ",buildBody, " colums :",columns," data : ",data);
    
     data = data.filter((value, ind) => {
       {
        // const userSearchedValuesAllTheIndexes = [1, 45, 56];
         var tmpdata = ''
         userSearchedResultIndexes.forEach(element => {
           if (value.index === element) { tmpdata = value; }
         });
         return tmpdata;
       }
     })
     return `${buildHead(columns)}${buildBody(data)}`.trim();
   },*/
   
  //   onTableChange: (action, tableState) => {
  //   console.log("Useranalytics table change data : ",action,tableState);
  //   if(action == "search"){
  //     var indexes = tableState?.displayData.map((obj)=>{return obj?.dataIndex});
  //     setUserSearchedResultIndexes(indexes);
  //   }
  // },
  };
  return (
    <div>
      <Box component="main" mx={3} mt={3}>
        <Box className={classes.boxLayout}>
          <Box
            display="dlock"
            bgcolor="#1a1a31"
            className={classes.breadcrumbBox}
          >
            <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpenForm} />}/>
          </Box>
          <div>
            <Box component="div" className="pos_relative">


              {/*<Button onChange={handleClickOpen}/>*/}

              <Dialog
                open={openform}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
              >
                <DialogTitle id="scroll-dialog-title" color="white">Support Ticket</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                  <DialogContentText
                    id="scroll-dialog-description"
                    //ref={descriptionElementRef}
                    tabIndex={-1}
                  >
                    <p className="subtitle">Help On Support Ticket</p><br />
                    <img className="maxwidth100" src="/assets/images/Support_Ticket_help_section1.jpg"></img><br /><br />
                    <p>
                      <li>Click search button <img src={searchicon} alt="" width="40px" height="40px" /> to search the entire table</li><br />
                      <li>Click download button <img src={downloadicon} alt="" width="40px" height="40px" /> to download the table in excel</li><br />
                      <li>Click print button <img src={printicon} alt="" width="40px" height="40px" /> to open the print options</li><br />
                      <li>Click view column button <img src={viewcolumnicon} alt="" width="40px" height="40px" /> to display column name fields</li><br />
                      <li>Click filter button <img src={filtericon} alt="" width="40px" height="40px" /> to open the filter options</li><br />
                      <li>Click the edit button will edit the particular support ticket</li>
                    </p>
                    <img className="maxwidth100" src="/assets/images/Support_Ticket_help_section2.jpg"></img><br /><br />
                    <p>
                    <li>Select the <img src={Checkbox} alt="" width="30px" height="30px" /> and click <DeleteIcon/> on the top of the grid to delete particular row</li><br/>
                    </p>

                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClickClose}>Close</Button>
                </DialogActions>
              </Dialog>
            </Box>
          </div>
          <Box
            display="flex"
            className= "reportstablehead"
            alignItems="center"
            px={1}
            pt={3}
            pb={3}
          >
             <ThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                title={"Support Ticket"}
                className={classes.tableBody}
                data={registeredUsers}
                 
                columns={columns}
                options={options}
              />
              {/* <Confirmation open={openAlert} onClose={handleClose} onHandleSubmit={onAlertSubmit} BMhistorydata={Bunkermasterhistory} /> */}
            </ThemeProvider>
            {/* <Box width={0.8}>
              <Box display="flex" alignItems="center">
                <Box component="span" fontSize="16px">
                  {"Search"}
                </Box>
                <Box component="span" ml={2} width="260px">
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="search"
                    className={classes.txtInput}
                    placeholder="Type"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </Box>
                <Box component="span" ml={2} width="auto">
                  <Button
                    className={classes.btnStyle1}
                    onClick={(e) => filterGrid()}
                  >Search</Button>
                </Box>
                <Box component="span" ml={3} width="260px" style={{ marginLeft: 10 }} >
                  <Button
                    className={classes.btnStyle1}
                    onClick={() => getSupportUser()}
                  >Clear</Button>
                </Box>
              </Box>
            </Box> */}

          </Box>
          {/* <Box className={classes.root} pb={3} px={1}>
             <TableContainer component={Paper} className={classes.tableLayout}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                  <StyledTableCell>Ticket Id</StyledTableCell>
                    <StyledTableCell>Name</StyledTableCell>
                    <StyledTableCell>Description</StyledTableCell>
                    <StyledTableCell>Attachment Id</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Created Date</StyledTableCell>
                    <StyledTableCell>Last Modified Date</StyledTableCell>
                    <StyledTableCell>Actions</StyledTableCell> 
                  </TableRow>
                </TableHead>
                <TableBody>
                  {registeredUsers.length
                    ? registeredUsers.map((row) => (
                        <Row onDownloadPic={onDownloadPic} key={row.username}  editUserDetails = {onEditUserDetails}  row={row} />
                      ))
                    : ""}
                </TableBody>
              </Table>
            </TableContainer> 
            
          </Box> */}
        </Box>
      </Box>
    </div>
  );
}
